import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/sonner";

// Pages
import Login from "./pages/Login";
import PublicStats from "./pages/PublicStats";
import Dashboard from "./pages/Dashboard";
import Events from "./pages/Events";
import Picks from "./pages/Picks";
import NewPick from "./pages/NewPick";
import PickDetail from "./pages/PickDetail";
import Profile from "./pages/Profile";
import Stats from "./pages/Stats";
import Publishing from "./pages/Publishing";
import AdminReels from "./pages/AdminReels";
import AdminPublisher from "./pages/AdminPublisher";
import AdminMarketsInsights from "./pages/AdminMarketsInsights";
import Publicaciones from "./pages/Publicaciones";
import AdminTelegram from "./pages/AdminTelegram";
import AdminControl from "./pages/AdminControl";
import WeeklyReport from "./pages/WeeklyReport";

function App() {
  return (
    <AuthProvider>
      <div className="dark">
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/stats" element={<PublicStats />} />
            <Route path="/track" element={<PublicStats />} />
            
            {/* Redirect root to dashboard */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            
            {/* Protected Routes */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/events" element={
              <ProtectedRoute>
                <Events />
              </ProtectedRoute>
            } />
            <Route path="/picks" element={
              <ProtectedRoute>
                <Picks />
              </ProtectedRoute>
            } />
            <Route path="/picks/new" element={
              <ProtectedRoute>
                <NewPick />
              </ProtectedRoute>
            } />
            <Route path="/picks/:id" element={
              <ProtectedRoute>
                <PickDetail />
              </ProtectedRoute>
            } />
            <Route path="/profile" element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            } />
            <Route path="/admin/stats" element={
              <ProtectedRoute>
                <Stats />
              </ProtectedRoute>
            } />
            <Route path="/publishing" element={
              <ProtectedRoute>
                <Publishing />
              </ProtectedRoute>
            } />
            <Route path="/admin/reels" element={
              <ProtectedRoute>
                <AdminReels />
              </ProtectedRoute>
            } />
            <Route path="/admin/publisher" element={
              <ProtectedRoute>
                <AdminPublisher />
              </ProtectedRoute>
            } />
            <Route path="/admin/markets-insights" element={
              <ProtectedRoute>
                <AdminMarketsInsights />
              </ProtectedRoute>
            } />
            <Route path="/publicaciones" element={
              <ProtectedRoute>
                <Publicaciones />
              </ProtectedRoute>
            } />
            <Route path="/admin/telegram" element={
              <ProtectedRoute>
                <AdminTelegram />
              </ProtectedRoute>
            } />
            <Route path="/admin/control" element={
              <ProtectedRoute>
                <AdminControl />
              </ProtectedRoute>
            } />
            <Route path="/admin/weekly-report" element={
              <ProtectedRoute>
                <WeeklyReport />
              </ProtectedRoute>
            } />
            
            {/* Redirects for old/moved/removed routes */}
            <Route path="/backtest" element={<Navigate to="/dashboard" replace />} />
            <Route path="/risk" element={<Navigate to="/dashboard" replace />} />
            <Route path="/election" element={<Navigate to="/picks" replace />} />
            <Route path="/history" element={<Navigate to="/dashboard" replace />} />
            <Route path="/special-bets" element={<Navigate to="/picks" replace />} />
            <Route path="/marketing" element={<Navigate to="/dashboard" replace />} />
            <Route path="/ml-config" element={<Navigate to="/dashboard" replace />} />
            <Route path="/admin/music" element={<Navigate to="/admin/reels" replace />} />
            <Route path="/admin/stake10" element={<Navigate to="/picks" replace />} />
            <Route path="/admin/btts-calibration" element={<Navigate to="/admin/markets-insights" replace />} />
            <Route path="/stake10" element={<Navigate to="/picks" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </AuthProvider>
  );
}

export default App;
